import Image from 'next/image';
import React from 'react';

const MagnateIcon = () => {
	return (
		<Image
			src="/img/vip/levels/icon-magnate.webp"
			alt="Magnate Icon"
			width="88"
			height="88"
			className="w-full h-auto"
		/>
	);
};

export default MagnateIcon;
